import { Typography, withStyles } from "@material-ui/core";
import { Card, LoadingIcon, Select } from "bc-front-sagacomponents";
import { formatDateCourt } from "../../../../helpers/formatters";
import { AdherentParticulierResponse } from "../../../../services/Api/swagger";
import styles from "../../style";
import { useCarteFidelite } from "./selectors";

interface Props {
  classes?: any;
  listeAdherents?: AdherentParticulierResponse[];
}
const CarteFidelite = (props: Props) => {
  const { classes, listeAdherents } = props;

  const {
    selectedFondCarte,
    fetchingFondCarte,
    errorFondCarte,
    selectedAdhesion,
    immatList,
    handleChangeFondCarte,
  } = useCarteFidelite();

  const infoAdherent =
    listeAdherents &&
    listeAdherents.find((adh) =>
      adh.listAdhesion?.find(
        (adhesion) =>
          selectedAdhesion &&
          adhesion.numeroAdhesion === selectedAdhesion.numeroAdhesion
      )
    );

  const url =
    selectedFondCarte && "data:image/png;base64, " + selectedFondCarte.content;

  if (selectedFondCarte) {
    return (
      <Card className={classes.cardFondCarte}>
        {selectedAdhesion && url && (
          <div className={classes.containerFondCarte}>
            {selectedFondCarte && (
              <div
                className={classes.fondCarte}
                style={{ backgroundImage: "url('" + url + "')" }}
              >
                <div className={classes.containerContentFondCarte}>
                  <div>
                    <p>Nom du concessionnaire</p>
                    <p>{selectedAdhesion.nomClient}</p>
                  </div>

                  <div>
                    <p>
                      N° adhérent
                      {selectedAdhesion.numeroFidelite && selectedAdhesion.numeroFidelite !== '0' && selectedAdhesion.numeroAdhesion !== selectedAdhesion.numeroFidelite && (
                        <span>/ N° Fidélité</span>
                      )}
                    </p>
                    <p>
                      {selectedAdhesion.numeroAdhesion}
                      {selectedAdhesion.numeroFidelite && selectedAdhesion.numeroFidelite !== '0' && selectedAdhesion.numeroAdhesion !== selectedAdhesion.numeroFidelite && (
                        <span> / {selectedAdhesion.numeroFidelite}</span>
                      )}
                    </p>
                  </div>

                  <div>
                    <p>Nom du propriétaire</p>
                    <p>
                      {infoAdherent &&
                        infoAdherent.nom + " " + infoAdherent.prenom}
                    </p>
                  </div>

                  {selectedAdhesion.marque && (
                    <div>
                      <p>Immatriculation</p>
                      <p>{selectedAdhesion.immatriculation}</p>
                    </div>
                  )}

                  {selectedAdhesion.dateEcheance &&
                    selectedAdhesion.editionDateFin && (
                      <div>
                        <p>Date de fin d'effet</p>
                        <p>{formatDateCourt(selectedAdhesion.dateEcheance)}</p>
                      </div>
                    )}
                </div>
              </div>
            )}
          </div>
        )}
        {fetchingFondCarte && <LoadingIcon />}
        {errorFondCarte && (
          <Typography color="error">Impossible d'afficher la carte</Typography>
        )}{" "}
        {immatList && immatList.length > 1 && (
          <Select
            name="immatriculation"
            label="Immatriculation"
            options={immatList}
            onChange={handleChangeFondCarte}
            value={selectedAdhesion?.immatriculation}
            required
            noDelete
          />
        )}
      </Card>
    );
  } else return null;
};

export default withStyles(styles)(CarteFidelite);
